<template>
  <DefInsertTilda
    v-if="getHtmlFromTilda"
    :result="getHtmlFromTilda"
    :width="getWidth"
    :height="getHeight"
  />
</template>

<script>
import DefInsertTilda from '@components/Def/DefInsertTilda/DefInsertTilda.vue';
import useDeviceInfo from '@use/useDeviceInfo';

export default {
  name: 'DefInsertTildaSlider',
  components: { DefInsertTilda },
  props: ['result'],
  data() {
    return {
      deviceScreen: useDeviceInfo().screen,
    };
  },
  computed: {
    getHtmlFromTilda() {
      return this.result?.[this.deviceScreen]?.vHtml ?? this.result.vHtml;
    },
    getWidth() {
      return this.result?.[this.deviceScreen]?.width ?? this.result.width;
    },
    getHeight() {
      return this.result?.[this.deviceScreen]?.height ?? this.result.height;
    },
  },
};
</script>

<style lang="scss" scoped>
.def-insert-tilda-slider {
}
</style>
